<div class="gd-image-download {{ image.orientation }} tw-flex tw-flex-col tw-justify-between gd-global-material-dialog-padding"
  [dir]="dir$ | async">
  <h2 style="margin: 0 0 20px;" i18n="Image renditions modal title" i18n>Image renditions</h2>
  <div class="tw-flex tw-justify-center tw-gap-6">

    <div class="tw-flex tw-justify-center tw-items-start tw-flex-100 tw-max-w-[35%] gd-image-download__image-wrapper">
      @if (imageSrc) {
        <div
          class="gd-image-download__image {{ image.orientation }}"
          [ngStyle]="{'background-image': 'url(' + imageSrc + ')'}"
          [class.--icon]="isScaleDownRequired(image)">
        </div>
      }
      @if (!imageSrc) {
        <div
          class="gd-image-download__image-placholder">
          <mat-spinner color="accent"
            diameter="55">
          </mat-spinner>
        </div>
      }

    </div>

    <div class="tw-flex-100 tw-max-w-[65%]">
      <div class="gd-image-download__image-renditions gd-custom-scrollbar">
        <gd-renditions-view [renditions]="image.formats" (previewChange)="updatePreview($event)"></gd-renditions-view>
      </div>
    </div>

  </div>

  <div class="gd-image-download__actions tw-flex tw-justify-end tw-gap-3">
    <button mat-button
      mat-raised-button
      mat-dialog-close
      i18n="Image download modal button"
      i18n>
      Cancel
    </button>
  </div>
</div>
